export default{
    check_if_empty_field(data, ignore){
        if (typeof data == "string") {
          if (data == undefined || data.trim() == "")
          {
            console.log("verification failed for "+data)
            return false
          }
          
        }
        else if (Array.isArray(data)) {
          for (var k = 0; k < data.length; k++) {
            if(this.check_if_empty_field(data[k], ignore) == false)
              return false
          }
        }
        else if (typeof data == "object") {
          if (data == null) {
            console.log("verification failed for "+data)
            return false
          }
          else{
            ignore.forEach(function(key) {
              if (key in data) delete data[key];
            });
            for (var key in data) {
              if(this.check_if_empty_field(data[key], ignore) == false){
                console.log("verification failed for "+key)
                return false
              }
            }
          }
        }
    },

    verify_reply_markup(reply_markup) {
        if ("keyboard" in reply_markup) {
          for (var i = 0; i < reply_markup.keyboard.length; i++) {
            let row = reply_markup.keyboard[i];
            for (var j = 0; j < row.length; j++) {
              let btn = row[j];
              if (btn.text == null || btn.text.trim() == "") {
                return false;
              }
            }
          }
        }
        if ("inline_keyboard" in reply_markup) {
          for (i = 0; i < reply_markup.inline_keyboard.length; i++) {
            let row = reply_markup.inline_keyboard[i];
            for (j = 0; j < row.length; j++) {
              let btn = row[j];
              let btype = btn.type;
              if (btn.text == null || btn.text.trim() == "") {
                return false;
              }
              if (btype == "login_url") {
                if (btn.login_url.url == null || btn.login_url.url.trim() == "") {
                  return false;
                }
              } else {
                if (btn[btype] == null || btn[btype].trim() == "") {
                  return false;
                }
              }
            }
          }
        }
        return true;
    },
}